import { PesticidesValidator } from './pesticidesValidator';
import { registeredPesticidesFieldValidators } from './fieldValidators';

export const registeredPesticidesValidator = new PesticidesValidator(
  registeredPesticidesFieldValidators,
);
